// extracted by mini-css-extract-plugin
export default {"inputWrapper":"inputWrapper--rGLKX"};